import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import * as _echarts from 'echarts';
import moment, { Moment } from 'moment';

const echarts: any = _echarts;

@Component({
    selector: 'pro-time-graph',
    template: `
        <div class="Chart" #chart>
        </div>
    `,
    styles: [`
        .Chart {
            min-height: 250px;
        }
    `]
})

export class TimeGraphComponent implements OnInit, OnChanges {
    @Input() date: { dienuSk: number, from: string, to: string };
    @Input() data: { data: { time: string, start: Moment, end: Moment }[], label: string }[];
    @Input() timeStamp: any;
    @Input() tooltipFunc: any = (d: any) => '';
    @ViewChild('chart', { static: true }) element: ElementRef;

    chartConfig: any = {

    }

    constructor() {}

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {
        this.draw();
    }

    draw() {
        if (!this.data) return;

        const myChart = echarts.init(this.element.nativeElement);
        const data: any[] = [];
        const yAxisLabels = Object.values(this.data).map((item) => item.label);
        const flatData: any[] = [];
        Object.values(this.data).forEach((item) => {
            item.data = item.data.map((d: any) => ({ ...d, label: item.label}));
            flatData.push(...item.data);
        })

        function getCategoryIndex(value: any) {
            switch (value.label) {
                case yAxisLabels[0]: return 0;
                case yAxisLabels[1]: return 1;
                case yAxisLabels[2]: return 2;
            }
        }

        flatData.forEach((d) => {
            // console.log(d.start.isAfter(moment(this.date.from)), d.end.isBefore(moment(this.date.to)));
            if (d.start.isAfter(moment(this.date.from)) && d.end.isBefore(moment(this.date.to))) {
                data.push({
                    name: d.label,
                    values: [getCategoryIndex(d), d.start.unix(), d.end.unix(), d.start.format('YYYY-MM-DD HH:mm:ss'), d.end.format('YYYY-MM-DD HH:mm:ss')],
                });
            }
        });
        // console.log('data: ', data);
        // console.log('flatdata: ', flatData);

        const option = {
            tooltip: {
                trigger: 'axis',
                confine: true,
            },
            grid: {
                // height: 300
            },
            xAxis: {
                // type: 'time',
                axisLabel: {
                    formatter: function(val: number) {
                        return moment.unix(val).format('YYYY-MM-DD HH:mm:ss');
                    },
                },
                splitLine: {
                    show: true,
                },
                // interval: moment.duration(12, 'hour').asMilliseconds(),
                // axisTick: {
                //     show: true,
                //     interval: moment.duration(12, 'hour').asMilliseconds(),
                // },
                // minorTick: {
                //     show: true,
                //     interval: moment.duration(3, 'hour').asMilliseconds(),
                // },
                scale: true,
            },
            yAxis: {
                data: yAxisLabels,
            },
            series: [{
                type: 'custom',
                renderItem: function (params: any, api: any) {
                    const categoryIndex = api.value(0);
                    const start = api.coord([api.value(1), categoryIndex]);
                    const end = api.coord([api.value(2), categoryIndex]);
                    const height = api.size([0, 1])[1] * 0.6;

                    const rectShape = echarts.graphic.clipRectByRect({
                        x: start[0],
                        y: start[1] - height / 2,
                        width: end[0] - start[0],
                        height: height,
                    }, {
                        x: params.coordSys.x,
                        y: params.coordSys.y,
                        width: params.coordSys.width,
                        height: params.coordSys.height
                    });

                    // console.log(categoryIndex, api.value(1), height);
                    return rectShape && {
                        type: 'rect',
                        shape: rectShape,
                        style: api.style()
                    };
                },
                itemStyle: {
                    color: function(params: any) {
                        const colors = ['green', 'blue', 'darkorange', 'red', 'violet'];
                        return colors[params.value[0]];
                    }
                },
                encode: {
                    x: [1, 2],
                    y: [0],
                    tooltip: [3, 4],
                },
                data: data.map((item: any) => item.values),
            }]
        };
        myChart.setOption(option);
    }

}
